import React from 'react'
import PropTypes from 'prop-types'
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'

import './Splash.scss'

const Splash = ({ title, logo, isVisible }) => {
  return (
    <CSSTransitionGroup
      transitionName='fi_splash'
      transitionEnterTimeout={1400}
      transitionLeaveTimeout={1000}
    >
      {isVisible &&
        <div className={'fi_splash'} >
          <div id='fi_splash__logo' className='fi_splash__logo' style={{ backgroundImage: `url(${logo})` }} />
          <div className='fi_splash__divider' />
          <div id='fi_splash__title' className='fi_splash__title'><span className='fi_splash__title--text'>{ title }</span></div>
        </div>
      }
    </CSSTransitionGroup>
  )
}

Splash.propTypes = {
  title: PropTypes.string,
  logo: PropTypes.string,
  isVisible: PropTypes.bool,
}

export default Splash



// WEBPACK FOOTER //
// ./src/templates/fashionIcon/components/Splash.js